import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';
import s from './Button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'subtle';
export type ButtonSize = 'sm' | 'md' | 'lg';

/** Class names for anything that should look like a button (e.g. a Next.js <Link>). */
export function buttonClass(variant: ButtonVariant = 'primary', size: ButtonSize = 'md', opts: { block?: boolean; iconOnly?: boolean } = {}): string {
  return cx(s.btn, s[variant], s[size], opts.block && s.block, opts.iconOnly && s.icon);
}

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  block?: boolean;
  loading?: boolean;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  /** Square icon-only button; give it an aria-label. */
  iconOnly?: boolean;
}

export function Button({ variant = 'primary', size = 'md', block, loading, iconLeft, iconRight, iconOnly, className, children, disabled, type = 'button', ...rest }: ButtonProps) {
  return (
    <button type={type} className={cx(buttonClass(variant, size, { block, iconOnly }), className)} disabled={disabled || loading} aria-busy={loading || undefined} {...rest}>
      {loading ? <span className={s.spinner} aria-hidden /> : iconLeft}
      {children}
      {!loading && iconRight}
    </button>
  );
}
